module.exports = __webpack_public_path__ + "img/bay-hotel-3.02a04b17.jpg";